/* eslint-disable */
// numeral.js locale configuration
// locale : English Ireland (ie)
// See https://github.com/adamwdraper/Numeral-js/pull/551/files

import numeral from 'numeral';

numeral.register('locale', 'en-ie', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function (number) {
    var b = number % 10;
    return (~~ (number % 100 / 10) === 1) ? 'th' :
        (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
  },
  currency: {
    symbol: '€'
  }
});
